import { IconButton, type IconButtonProps } from '@affine/component';
import { SelectionCheckbox } from '@affine/core/components/selection-checkbox';
import clsx from 'clsx';
import { forwardRef } from 'react';

import * as styles from './quick-action-control.css';

export const QuickActionIconButton = forwardRef<
  HTMLButtonElement,
  IconButtonProps
>(function QuickActionIconButton({ className, ...props }, ref) {
  return (
    <IconButton
      ref={ref}
      className={clsx(styles.quickActionButton, className)}
      {...props}
    />
  );
});

export interface QuickSelectActionButtonProps extends Omit<
  IconButtonProps,
  'children' | 'icon'
> {
  checked: boolean;
}

export const QuickSelectActionButton = forwardRef<
  HTMLButtonElement,
  QuickSelectActionButtonProps
>(function QuickSelectActionButton({ checked, iconClassName, ...props }, ref) {
  return (
    <QuickActionIconButton
      ref={ref}
      iconClassName={clsx(styles.quickSelectActionIcon, iconClassName)}
      icon={
        <SelectionCheckbox
          checked={checked}
          style={{ pointerEvents: 'none' }}
        />
      }
      {...props}
    />
  );
});
